import Config from "../../../env/config";
// SlideModal.js
// eslint-disable-next-line no-unused-vars
import React, { useEffect, useState } from "react";
import { useLang } from "../../../Utility/hooks/useLang";
import './SlideModal.scss';
// import Accordion from '@mui/material/Accordion';
import { useTranslation } from "react-i18next";
// import AccordionSummary from '@mui/material/AccordionSummary';
// import AccordionDetails from '@mui/material/AccordionDetails';
// import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
// import { Link } from "react-router-dom";
// import Button from '@mui/material/Button';
const SlideModal = ({ isOpen, onClose, children, lang: propLang, isLoggedIn, fullName, mobile, signOut }) => {
  const CDN_URL = Config.CDN_URL;

  // const { t, i18n } = useTranslation();
  // const [isClassOpen1, setClassOpen1] = useState(false);
  // const [isClassOpen2, setClassOpen2] = useState(false);
  // const [isClassOpen3, setClassOpen3] = useState(false);
  // const [isClassOpen4, setClassOpen4] = useState(false);
  // const [isClassOpen5, setClassOpen5] = useState(false);
  // const [isActiveClass1, setIsActiveClass1] = useState(false);
  // const [isActiveClass2, setIsActiveClass2] = useState(false);
  // const [isActiveClass3, setIsActiveClass3] = useState(false);
  // const [isActiveClass4, setIsActiveClass4] = useState(false);
  // const [isActiveClass5, setIsActiveClass5] = useState(false);
  const { lang: hookLang } = useLang();
  const lang = propLang || hookLang;

  return (
    <>
      {isOpen && (
        <div className="modal-overlay">
          <div className="modal slideMenu">
            <div className="modal-content">
              <div className='hamburgClose' onClick={onClose}>
                <img src={`${CDN_URL}menuHandBurgIcon.webp`} />
              </div>
              <div className='scrollbarDiv'>
                <div className='Hambergermenu'>
                  <div className='menuWhitelogo'>
                    <img src={`${CDN_URL}menuWhiteLogo.webp`} />
                    {/* <div className="onic-group">(ONEIC Group Company)</div> */}
                    {lang === "ar" ? <div className="onic-group">(مجموعة شركات أونك)</div> : <div className="onic-group">(ONEIC Group Company)</div>}
                  </div>
                  <div className='verticleline'></div>
                  <ul className='contactlist'> {/* <li>
              <a href='#'>
                <img src={`${CDN_URL}menuHomeIcon.webp`} />{t("SM_HOME")} </a>
            </li>
            <li>
              <a href='#'>
                <img src={`${CDN_URL}aboutusIcon.webp`} />{t("SM_ABOUT_US")} </a>
            </li> */}
                    <li>
                      {lang === "ar" ?
                        <a href='#'>
                          <img src={`${CDN_URL}whatWeAreIcon.webp`} />
                          معنا
                        </a>
                        :
                        <a href='#'>
                          <img src={`${CDN_URL}whatWeAreIcon.webp`} />Contact US
                        </a>
                      }
                    </li>

                    <li>
                      {lang === "ar" ?
                        <a href='https://wa.me/96872227122'>
                          <img src={`${CDN_URL}whatsapp.webp`} />
                          WhatsApp<br />
                          +968 72227122
                        </a>
                        :
                        <a href='https://wa.me/96872227122'>
                          <img src={`${CDN_URL}whatsapp.webp`} />
                          WhatsApp <br />
                          +968 72227122
                        </a>
                      }
                    </li>
                    <li>
                      {lang === "ar" ?
                        <a href='mailto:care@tameen.om'>
                          <img src={`${CDN_URL}email_2.webp`} />
                          البريد
                          <br /> care@tameen.om </a>
                        :

                        <a href='mailto:care@tameen.om'>
                          <img src={`${CDN_URL}email_2.webp`} />Email <br /> care@tameen.om </a>
                      }
                    </li>
                    <li>
                      {lang === "ar" ?
                        <a href='tel:+96824991999'>
                          <img src={`${CDN_URL}mobile.webp`} />
                          اتصل بنا <br />
                          +968 2499 1999 </a>
                        :
                        <a href='tel:+96824991999'>
                          <img src={`${CDN_URL}mobile.webp`} />Call Us <br /> +968 2499 1999 </a>
                      }
                    </li>
                    {/* <li>
              <a href='#'>
                <img src={`${CDN_URL}whatWeAreIcon.webp`} />SIGN IN </a>
            </li> */} {/* <li>
              <a href='#'>
                <img src={`${CDN_URL}ourTeamIcon.webp`} />{t("SM_OUT_TEAM")} </a>
            </li>
            <li>
              <a href='#'>
                <img src={`${CDN_URL}contactusIcon.webp`} />{t("SM_CONTACT_US")} </a>
            </li>
            <li>
              <a href='#'>
                <img src={`${CDN_URL}faqIcon.webp`} />{t("SM_FAQS")} </a>
            </li>
            <li>
              <a href='#'>
                <img src={`${CDN_URL}privacyPolicyIcon.webp`} />{t("SM_PRIVACY_POLICY")} </a>
            </li>
            <li>
              <a href='#'>
                <img src={`${CDN_URL}TermsConditionsIcon.webp`} />{t("SM_TERMS_AND_CONDITIONS")} </a>
            </li> */}
                  </ul>
                  <div className='verticleline'></div>
                  <ul className='hamburglist'> {/* <li>
              <a href='#'>
                <img src={`${CDN_URL}menuHomeIcon.webp`} />{t("SM_HOME")} </a>
            </li>
            <li>
              <a href='#'>
                <img src={`${CDN_URL}aboutusIcon.webp`} />{t("SM_ABOUT_US")} </a>
            </li> */}

                    <li>
                      {lang === "ar" ?
                        <a href='/claims-assistance'>
                          <span>
                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M6 3H14L19 8V21H6V3Z" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
                              <path d="M14 3V8H19" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
                              <path d="M9 14L11 16L15 12" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                          </span>
                          المطالبات
                        </a>
                        :
                        <a href='/claims-assistance'>
                          <span>
                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M6 3H14L19 8V21H6V3Z" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
                              <path d="M14 3V8H19" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
                              <path d="M9 14L11 16L15 12" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                          </span>
                          Claims Assistance
                        </a>
                      }
                    </li>
                    <li>
                      <a href='#'>
                        <span>
                          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M3 21H21" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
                            <path d="M5 21V10L9 7L13 10V21" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
                            <path d="M13 21V5L18 3V21" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
                            <path d="M8 12H10M8 15H10M16 8H17.5M16 11H17.5M16 14H17.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
                          </svg>
                        </span> {lang === "ar" ? <span>التأمين المركبات</span> : <span>Muscat, Oman </span>}

                      </a>
                    </li>
                    {/* <li>
              <a href='#'>
                <img src={`${CDN_URL}whatWeAreIcon.webp`} />SIGN IN </a>
            </li> */} {/* <li>
              <a href='#'>
                <img src={`${CDN_URL}ourTeamIcon.webp`} />{t("SM_OUT_TEAM")} </a>
            </li>
            <li>
              <a href='#'>
                <img src={`${CDN_URL}contactusIcon.webp`} />{t("SM_CONTACT_US")} </a>
            </li>
            <li>
              <a href='#'>
                <img src={`${CDN_URL}faqIcon.webp`} />{t("SM_FAQS")} </a>
            </li>
            <li>
              <a href='#'>
                <img src={`${CDN_URL}privacyPolicyIcon.webp`} />{t("SM_PRIVACY_POLICY")} </a>
            </li>
            <li>
              <a href='#'>
                <img src={`${CDN_URL}TermsConditionsIcon.webp`} />{t("SM_TERMS_AND_CONDITIONS")} </a>
            </li> */}
                  </ul>
                  {/* <div className="muscut-adrs">
              <h4>Tameen.om</h4>
<p>(ONEIC Group Company)</p>

<div className="nrTxt">ONEIC Tameen SPC</div>
<div className="nrTxt">Al Khuwair, Muscat, </div>
<div className="nrTxt">Sultanate of Oman.</div>



          </div>
          <div className='verticleline'></div>

          <div className="fsalicense"><b>FSA Licensed Insurance Broker</b><br/>
(License No - L2669345)</div> */}

                  <a href="https://www.google.com/maps/place/ONEIC,+3520+Wy,+Muscat/@23.594063,58.4195205,17z/data=!3m1!4b1!4m6!3m5!1s0x3e91ff098882735b:0xd53f2a4103cf3841!8m2!3d23.594063!4d58.4195205!16s%2Fg%2F1ptxy5y_3!18m1!1e1?entry=ttu&g_ep=EgoyMDI2MDgwNS4xIKXMDSoASAFQAw%3D%3D" target="_blank" rel="noreferrer" className="getdirection">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      viewBox="0 0 80 80"
                      fill="none"
                    >
                      <path
                        d="M40 73
       C37.5 69 17 44 17 28
       C17 15.3 27.3 5 40 5
       C52.7 5 63 15.3 63 28
       C63 44 42.5 69 40 73Z"
                        stroke="#FFFFFF"
                        stroke-width="5"
                        stroke-linejoin="round"
                      />

                      <circle
                        cx="40"
                        cy="28"
                        r="9"
                        stroke="#FFFFFF"
                        stroke-width="5"
                      />
                    </svg>
                    {lang === "ar" ? <span> احصل على الاتجاهات</span> : <span>Get Directions </span>}

                  </a>
                  {/* SIGNOUT BUTTON STARTS HERE */}
                  {isLoggedIn && (
                    <div className="profileSec">
                      <div className="topline"></div>
                      {fullName ? (
                        <div className="profielItemsFlx">
                          <span className="incItem">
                            <i className="fa-regular fa-user"></i>
                          </span>
                          <span className="profNm">{fullName}</span>
                        </div>
                      ) : null}
                      {mobile ? (
                        <div className="profielItemsFlx">
                          <span className="incItem">
                            <i className="fa fa-phone"></i>
                          </span>
                          <span className="profNm">{mobile}</span>
                        </div>
                      ) : null}
                      <div className="topline"></div>
                      <div
                        className="profielLogoutFlx"
                        onClick={() => {
                          if (typeof signOut === "function") signOut();
                          if (typeof onClose === "function") onClose();
                        }}
                      >
                        <span className="logoutInc">
                          <i className="fa fa-sign-out"></i>
                        </span>
                        <span className="profNm">{lang === "ar" ? "تسجيل الخروج" : "Signout"}</span>
                      </div>
                    </div>
                  )}
                  {/* SIGNOUT BUTTON ENDS HERE */}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default SlideModal;
